module.exports = __webpack_public_path__ + "img/IMG_4431.96e709ac.jpg";